import {Injectable} from '@angular/core';
import {environment} from 'environments/environment';
import {ApiEvsService} from 'app/common/services/ApiEvs.service';
import {Observable} from 'rxjs/Observable';
import {Headers, Http} from '@angular/http';

@Injectable()
export class IntegrateLoyaltyViewServices {
  headers: Headers;
  url = environment.qrcode_url_aps;

  constructor(private http: Http, private apiEvsService: ApiEvsService) {
    const token = localStorage.getItem('Access-Token');
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
  }

  loyaltyHistory(query?: any): Observable<any> {
    return this.http
      .get(`${this.url}/loyalty/settings`, {
        headers: this.headers,
        params: query,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  loyaltyDetail(id?: any): Observable<any> {
    return this.http
      .get(`${this.url}/loyalty/settings/${id}?systemType=${1}`, {headers: this.headers})
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  updateLoyaltyCampaign(body?: any): Observable<any> {
    return this.http
      .put(`${this.url}/loyalty/settings`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      })
  }

  removeLoyaltyCampaign(logIds?: any): Observable<any> {
    return this.http
      .delete(`${this.url}/loyalty/settings?logIds=${logIds}`, {
          headers: this.headers,
        }
      )
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      })
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/integrate-loyalty-v2/services/integrate-loyalty-view.services.ts